import type { DocEntityType } from "building-types/doc/docEntityTypes";
import type { DocEntityBase } from "building-types/entities/docEntityBase";
import type { Table } from "common/data/table";
import { SystemGroups } from "./docSystemGroups";
import { SystemDataSequences } from "./systemDataSequences";
import { SystemDrawingTemplates } from "./systemDrawingTemplates";
import { SystemParameters } from "./systemParameters";

/**
 * Returns a table of system entities for the given entity type that are not stored on the Doc.
 */
export function docGetSystemEntityTable<T extends DocEntityType>(entityType: T): Table<DocEntityBase<T>> {
  // Switch cases narrow `entityType` but not generic `T`; bridge via unknown.
  switch (entityType) {
    case "SYSTEM_PARAMETER":
      return SystemParameters as unknown as Table<DocEntityBase<T>>;
    case "DATA_SEQUENCE":
      return SystemDataSequences as unknown as Table<DocEntityBase<T>>;
    case "GROUP":
      return SystemGroups as unknown as Table<DocEntityBase<T>>;
    case "CONTENT_TEMPLATE":
      return SystemDrawingTemplates as unknown as Table<DocEntityBase<T>>;
    default:
      return {};
  }
}
